import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import KoVnTranslatorPage from './pages/KoVnTranslatorPage';
import EnVnTranslatorPage from './pages/EnVnTranslatorPage';

import './pages/global.css';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="ko-vn" element={<KoVnTranslatorPage />} />

                <Route path="/en-vn" element={<EnVnTranslatorPage />} />

                <Route path="/" element={<Navigate to="/ko-vn" replace />} />

            </Routes>
        </BrowserRouter>
    );
}

export default App;
